import { effect, signal } from "@preact/signals-react";

export const storedValue = signal(null)
export const setLocalStorage = (key, value) => {
    try {
        window.localStorage.setItem(key, JSON.stringify(value))
        storedValue.value = {key: key, value: JSON.stringify(value)}
    } catch (error) {
        console.log(error)
    }
}
export default function useLocalStorage(key, initialValue) {

    function getInitialValue(key, initialValue) {
        try {
            const item = window.localStorage.getItem(key)
            return item ? item : initialValue
        } catch (error) {
            console.log(error)
            return initialValue
        }
    }

    storedValue.value = getInitialValue(key, initialValue)
    return storedValue
}